import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DateService, HTTPService, HelperService } from 'app/services';

import { serviceAuthConsts } from 'app/constants';
import { demoEstimateData } from 'app/constants/demo-estimate';
import { currency } from 'app/constants/currency.constants';
import { itemTypeLabel, itemTypeLabelFR } from 'app/constants/itemType.constants';

import { sortBy } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-worksheet-pdf',
  templateUrl: './worksheet-pdf.component.html',
  styleUrls: ['./worksheet-pdf.component.scss'],
})
export class WorksheetPdfComponent implements OnInit {
  company: any = { address: {} };
  customer: any = {};
  vehicle: any = {};
  order: any = {};
  usd: string = currency.USD;
  disclaimer: string = '';
  invDisclaimer: string = '';
  pdfLogoType: string = '';
  milage: any = {};
  pdfImage: any = {};
  deferredServices: any = [];
  isDeferredServiceEnabled: boolean = false;
  isTireStorage2Enabled: boolean = false;
  showSign: boolean = true;
  techServiceGroup: any = {};
  unAssignedServiceGroup: any = { services: [] };
  techServiceGroupArray: any[] = [];
  isCustomerAddress: boolean = false;
  isCustomerContactDetails: boolean = false;
  isLoading = true;
  itemTypeLabel = itemTypeLabel;
  itemTypeLabelFR = itemTypeLabelFR;
  isTrackMileageInAndOut: boolean = false;
  currentLang: string = 'en';

  constructor(private activatedRoute: ActivatedRoute, private httpService: HTTPService, public helperService: HelperService, private renderer: Renderer2, private dateService: DateService, private translate: TranslateService) { }

  ngOnInit() {
    const token = this.activatedRoute.snapshot.paramMap.get('appt_conf_token');
    this.currentLang = this.activatedRoute.snapshot.queryParamMap.get('lang');
    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);

    const showSign = this.activatedRoute.snapshot.queryParamMap.get('showSign');
    // worksheetTech
    const id = this.activatedRoute.snapshot.paramMap.get('id');

    if (showSign === 'false') {
      this.showSign = false;
    }

    if (['8', '10', '12'].includes(`${token}`)) {
      demoEstimateData.company.appsettings.pdfFontSize = Number(token);
      demoEstimateData.company.appsettings.customerPreviewFontSize = Number(token);
      this.setData(demoEstimateData);
    } else if (token) {
      this.getEstimatesById(token);
    } else if (id) {
      this.getEstimatesByEstiamteId(id);
    }
  }

  getEstimatesByEstiamteId(id) {
    this.httpService.getEstimateByIdForTokenPreview(id).then(
      (res) => {
        this.setData(res);
        this.renderer.addClass(document.body, 'scroll-inspection');
        setTimeout(() => {
          window.print();
        }, 1000);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      }
    );
  }
  getEstimatesById(data: any) {
    const isShowPaymentDetails = true;
    this.httpService.getEstimateByIdCustomerTokenPreview(data, isShowPaymentDetails).then(
      (res: any) => {
        this.setData(res);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      }
    );
  }


  setData(res: any) {
    this.company = res.company;

    const shop = res.shop;
    const appsettings = this.company.appsettings;

    if (shop) {
      if (shop.pdfLogo) {
        this.company.logo = shop.pdfLogo;
        this.company.pdfLogo = shop.pdfLogo;
        this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
      } else {
        this.company.logo = shop.logo;
        this.company.pdfLogo = shop.pdfLogo;
      }
    } else if (this.company.pdfLogo) {
      this.company.logo = this.company.pdfLogo;
      this.pdfLogoType = appsettings.pdfLogoFormatType;
    }

    if (res.company && appsettings) {
      this.isDeferredServiceEnabled = appsettings.isDeferredServiceEnabled;
      this.isCustomerAddress = appsettings.isCustomerAddress;
      this.isCustomerContactDetails = appsettings.isCustomerContactDetails;
      this.isTrackMileageInAndOut = appsettings.isTrackMileageInAndOut && appsettings.isMileageMandatory && appsettings.isMileageInAndOutEnabled;
      this.isTireStorage2Enabled = appsettings.isTireStorage2Enabled;
    }

    if (appsettings.isMultiLocationEnabled) {
      this.isTrackMileageInAndOut = shop?.appsettings.isTrackMileageInAndOut && shop?.appsettings.isMileageMandatory && shop?.appsettings.isMileageInAndOutEnabled;
    }

    this.customer = res.estimate.customer;
    this.vehicle = res.estimate.vehicle;
    this.order = res.estimate;
    this.disclaimer = res.disclaimer;
    this.invDisclaimer = res.invDisclaimer;

    if (this.order.services && this.order.services.length) {
      const services = [];
      this.deferredServices = [];
      this.order.services.forEach((service: any) => {
        service.techName = service.tech && service.tech.name;
      });
      this.order.services = sortBy(this.order.services, 'techName');
      this.order.services.forEach((service: any) => {
        if (service?.serviceStatus !== 'deferred' && service?.serviceStatus !== 'declined') {
          service.items.forEach((item: any) => {
            if (item.description) {
              item.description = item.description.replace(/\n/g, '<br>');
            } 
            if (item?.descriptionFR) {
              item.descriptionFR = item.descriptionFR.replace(/\n/g, '<br>');
            }
          });
          if (service.tech && service.tech.techId) {
            if (!this.techServiceGroup[service.tech.techId]) {
              this.techServiceGroup[service.tech.techId] = {
                techId: service.tech && service.tech.techId,
                techName: service.tech && service.tech.name,
                services: [],
              };
            }
          } else {
            this.unAssignedServiceGroup.services.push(service);
          }
          if (service.tech && service.tech.techId) {
            this.techServiceGroup[service.tech.techId].services.push(service);
          }
        }
      });

      this.techServiceGroupArray = Object.values(this.techServiceGroup);

      if (this.unAssignedServiceGroup && this.unAssignedServiceGroup.services.length) {
        this.techServiceGroupArray.push({
          techId: '',
          techName: '',
          services: this.unAssignedServiceGroup.services,
        });
      }

      for (let i = 0; i < this.order.services.length; i++) {
        const { serviceStatus } = this.order.services[i];

        if (![serviceAuthConsts.declined, serviceAuthConsts.archived].includes(serviceStatus)) {
          if (serviceStatus === serviceAuthConsts.deferred || serviceStatus === serviceAuthConsts.deferredLocked) {
            this.deferredServices.push(this.order.services[i]);
          } else {
            services.push(this.order.services[i]);
          }
        }
      }

      this.order.services = services;
    }

    if (this.order.createdAt) {
      this.order.createdAt = this.dateService.getCurrentDateTimeTz(new Date(this.order.backdatedCreationDate || this.order.createdAt).getTime(), res.company.timezone);
    }

    if (this.order.invoiceDate) {
      this.order.invoiceDate = this.dateService.getCurrentDateTimeTz(new Date(this.order.invoiceDate).getTime(), res.company.timezone);
    }

    if (this.disclaimer) {
      this.disclaimer = this.disclaimer.replace(/\n/g, '<br>');
    }

    if (this.invDisclaimer) {
      this.invDisclaimer = this.invDisclaimer.replace(/\n/g, '<br>');
    }

    if (this.customer?.customerId?.address) {
      const { addLine1 = '', city = '', stateCode = '', zip = '', country = '' } = this.customer.customerId.address;
      const addressArr = [addLine1, city, stateCode];

      if (addLine1 || city || stateCode || zip) {
        addressArr.push(country || '');
      }
      addressArr.push(zip || '');
      this.customer.address = addressArr.filter((str) => !!str).join(', ');
    }

    if (this.company && this.company.address) {
      const { addLine1 = '', city = '', stateCode = '', country = '', zip = '' } = this.company.address;
      const addressArr = [addLine1, city, stateCode, country, zip || ''];
      this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
    }

    if (appsettings?.isMultiLocationEnabled && shop) {
      const shopDetailsKey = ['name', 'logo', 'email', 'phone'];

      shopDetailsKey.forEach((key: string) => {
        if (shop[key]) {
          this.company[key] = shop[key];
        }
      });

      if (shop.pdfLogo) {
        this.company.logo = shop.pdfLogo;
        this.company.pdfLogo = shop.pdfLogo;
        this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
      }

      if (shop.address?.addLine1) {
        const { addLine1 = '', city = '', stateCode = '', country = '', zip = '' } = shop.address;
        const addressArr = [addLine1, city, stateCode, country, zip];

        this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
      }
      this.isCustomerAddress = shop?.appsettings?.isCustomerAddress;
    }

    if (this.order?.vehicle?.vehicleId) {
      if (this.order.vehicleMileage?.reading && this.order.vehicleMileage?.mileageMeasuringUnit) {
        this.milage = {
          reading: this.order.vehicleMileage.reading,
          mileageMeasuringUnit: this.order.vehicleMileage.mileageMeasuringUnit,
        };
      }
    }

    this.isLoading = false;
  }

  renderTotalPLTO() {
    if (this.order && this.order.total) {
      const { total, hazmatFee } = this.order.total;

      return Number(total) - Number(hazmatFee);
    }

    return 0;
  }

  showRawTotal() {
    if (this.order && this.order.total) {
      const { total, hazmatFee } = this.order.total;

      return total - Number(hazmatFee);
    }

    return 0;
  }
}
